import classNames from 'classnames';
import { DashboardTheme } from 'containers/dashboard/types/types';
import { ClassName } from 'types/ClassName';
import DashboardList, { IDashboardListRow } from '../DashboardList/DashboardList';
import DashboardListItem from '../DashboardListItem/DashboardListItem';
import './DashboardActiveList.scss';

export interface IDashboardActiveListProps<IdType extends string = string> {
  onRowClick?: (id: IdType) => void;
  rowItems: Array<IDashboardListRow<IdType>>;
  theme: DashboardTheme;
  className?: ClassName;
}

function DashboardActiveList<IdType extends string = string>({
  onRowClick,
  rowItems,
  theme,
  className,
}: IDashboardActiveListProps<IdType>) {
  const classes = classNames('dashboard-active-list', className);

  function onItemClick(id: IdType) {
    return () => onRowClick?.(id);
  }

  return (
    <DashboardList
      className={classes}
      hover={!!onRowClick}
      rowItems={rowItems}
      theme={theme}
      renderItem={(item) => (
        <DashboardListItem
          onClick={onRowClick && item.value !== '' ? onItemClick(item.id) : undefined}
          key={item.id}
          label={item.label}
          theme={theme}
          value={item.value}
        />
      )}
    />
  );
}

export default DashboardActiveList;
